// de.ad.ts
const ad = {

start: {
  title: "Werbung",
  subtitle:
    "Bewirb deine Beiträge als kommerzielle Videos, verwalte deine Abrechnung und verfolge die Leistung deiner Kampagnen.",

  buttons: {
    newCampaign: "Neue Kampagne erstellen",
  },

  billingTitle: "Abrechnungsübersicht",

  billing: {
    managePayment: "Abrechnung verwalten",
    spendThisMonth: "Ausgaben diesen Monat",
    spendHint: "Basierend auf allen aktiven Kampagnen im aktuellen Abrechnungszeitraum.",
    impressions: "Impressionen",
    impressionsHint: "Gesamtzahl der Einblendungen deiner Werbung.",
    clicks: "Klicks",
    clicksHint: "Besuche auf deinen Links durch Werbeanzeigen.",
    paymentMethod: "Zahlungsmethode",
    paymentHint: "",
    changePayment: "Zahlungsmethode ändern",
    manageBillings: "Abrechnung verwalten",
  },

  status: {
    active: "Werbekonto aktiv",
  },

  steps: {
    title: "So funktioniert Werbung",
    step1: "Wähle einen bestehenden Beitrag zur Bewerbung aus oder lade ein neues Werbevideo hoch.",
    step2: "Lege dein Tagesbudget sowie die Länder oder Städte fest, in denen deine Werbung angezeigt werden soll.",
    step3:
      "Füge einen Link und einen Call-to-Action hinzu, damit Nutzer deine Website oder dein Profil besuchen können.",
    step4: "Überprüfe hier die Leistung deiner Kampagnen und pausiere oder bearbeite sie jederzeit.",
  },

  campaigns: {
    title: "Deine Kampagnen",
    none: "Noch keine Kampagnen",
    count: "{{count}} aktiv / Entwurf",
    emptyHint:
      "Sobald du deine erste Werbekampagne erstellt hast, erscheint sie hier mit Abrechnungs- und Leistungsdaten.",
    columns: {
      name: "Kampagne",
      status: "Status",
      spend: "Ausgaben (diesen Monat)",
      impressions: "Impressionen",
      clicks: "Klicks",
    },
    pause: "Pausieren",
    resume: "Fortsetzen",
    end: "Beenden",
    view: "Anzeigen",
  },
},

overview: {
  alerts: {
    noMediaAttached: "Keine Medien an diese Werbung angehängt.",
    missingTargetUrl: "Ziel-URL fehlt.",
    invalidUrl: "Bitte gib eine gültige URL ein, die mit http:// oder https:// beginnt.",
    uploadNoMediaProcessed: "Upload fehlgeschlagen: Es konnten keine Medien verarbeitet werden.",
    launchFailed: "Kampagne konnte nicht gestartet werden. Bitte versuche es erneut.",
  },

  campaignDetails: {
    title: "Kampagnendetails",
    nameLabel: "Kampagnen- / Projektname",
    namePlaceholder: "z. B. Frühlingsangebot Video",
    helper:
      "Dieser Name erscheint nur in deiner Werbeübersicht und nicht in der Anzeige selbst.",
  },

  targeting: {
    title: "Wo soll deine Werbung erscheinen?",
    modes: {
      world: "🌍 Weltweit",
      continent: "🌐 Nach Kontinent",
      countries: "🗺️ Nach Ländern",
    },
    continentLabel: "Kontinent",
    continentHelperPrefix: "Deine Werbung kann Nutzern in folgendem Gebiet angezeigt werden:",
    countriesLabel: "Länder",
    selectedPrefix: "Ausgewählt:",
    noneSelected: "Noch kein Land ausgewählt",
  },

  budget: {
    title: "Budget & Auslieferung",
    dailyBudgetLabel: "Tagesbudget",
    perDaySuffix: "€ / Tag",
    endDateLabel:
      "Enddatum (optional). Leer lassen für unbegrenzte Laufzeit. Die Werbung kann jederzeit im Werbemanager beendet werden.",
    deliveryQuestion: "Wie häufig soll deine Werbung ausgespielt werden?",
    deliveryModes: {
      light: "💤 Gering",
      balanced: "⚖️ Ausgewogen",
      frequent: "🚀 Häufig",
    },
    estimatePrefix: "Mit",
    estimateMiddle: "kann deine Werbung ungefähr",
    estimateSuffix: "Impressionen pro Tag erreichen.",
  },

  actions: {
    back: "← Zurück",
    launch: "🚀 Kampagne starten & hochladen",
  },

  summary: {
    title: "Kampagnenübersicht",
    rows: {
      location: "Standort",
      dailyBudget: "Tagesbudget",
      totalBudget: "Gesamtbudget",
      endDate: "Enddatum",
      delivery: "Auslieferung",
    },
    worldwide: "Weltweit",
    noCountrySelected: "Kein Land ausgewählt",
    deliveryValues: {
      light: "Gering (seltener anzeigen)",
      balanced: "Ausgewogen",
      frequent: "Häufig (öfter anzeigen)",
    },
    billingNote: "Abrechnung pro 1.000 Impressionen (CPM) in EUR.",
  },

  preview: {
    sponsored: "Gesponsert",
    visitWebsiteFallback: "Website besuchen",
    ctaDisabledTitle:
      "Füge im vorherigen Schritt eine gültige URL hinzu, um diese Schaltfläche zu aktivieren.",
    noMediaAttachedHint:
      "Keine Medien angehängt – gehe zurück und füge mindestens ein Bild oder Video hinzu.",
  },
},

upload: {
  header: {
    title: "Neue Werbeanzeige erstellen",
  },
  media: {
    uploading: "Wird hochgeladen",
    noPreview: "Keine Vorschau verfügbar",
    addTile: {
      title: "Hier klicken, um Bilder & Videos auszuwählen",
      subtitle: "…oder hierher ziehen",
    },
  },
  buttons: {
    filter: "Filter",
    music: "Musik",
    delete: "Löschen",
  },
},

new: {
  alerts: {
    needMedia: "Bitte füge mindestens ein Bild oder Video hinzu.",
    needUrl: "Bitte gib einen Link für deine Werbung ein.",
    badUrl: "Bitte gib eine gültige URL ein, die mit http:// oder https:// beginnt.",
    needButtonLabel:
      'Bitte gib eine Beschriftung für den Werbe-Button ein (z. B. „Jetzt kaufen“).',
  },
},

alerts: {
  mediaPerPostLimit:
    "Du hast die maximale Anzahl an Medien für diese Werbeanzeige erreicht.",
  mediaPerPostHardLimit:
    "Einige Dateien wurden übersprungen, weil das Medienlimit erreicht wurde.",
  videosSkippedTooLongShort:
    "Einige Videos wurden übersprungen, weil sie zu lang sind.",
  videosSkippedTooLongSummary:
    "Einige Videos wurden übersprungen, weil sie die maximale Länge überschreiten.",
  filesSkippedByCapSummary:
    "Einige Dateien wurden übersprungen, weil das Medienlimit erreicht wurde.",
},

// ✅ Für ChangePayment.tsx
payment: {
  title: "Zahlungsmethode ändern",
  subtitle:
    "Wähle aus, wie du für deine Werbekampagnen bezahlen möchtest. Du kannst dies jederzeit ändern.",

  backToBilling: "Zurück zur Werbung",

  saved: "Deine Zahlungsmethode wurde aktualisiert (nur Demo, noch keine echte Abrechnung).",

  buttons: {
    save: "Änderungen speichern",
    cancel: "Abbrechen",
  },

  methods: {
    title: "Zahlungsmethoden",
    card: "Kredit- / Debitkarte",
    sepa: "SEPA-Lastschrift",
    wallet: "Apple Pay / Google Pay",
    note:
      "Deine Standard-Zahlungsmethode wird für zukünftige Abbuchungen verwendet, sofern für eine Kampagne keine zusätzliche Bestätigung erforderlich ist.",
  },

  card: {
    name: "Name des Karteninhabers",
    namePlaceholder: "Name wie auf der Karte angegeben",
    number: "Kartennummer",
    expiry: "Gültig bis",
    cvc: "CVC",
    hint:
      "Wir unterstützen Visa, Mastercard und American Express. Deine Kartendaten werden sicher verarbeitet.",
  },

  paypal: {
    email: "PayPal-E-Mail",
    hint:
      "Bei Bedarf wirst du für zukünftige Abbuchungen zur Bestätigung zu PayPal weitergeleitet.",
  },


  sepa: {
  name: "Kontoinhaber",
  namePlaceholder: "Vollständiger Name des Kontoinhabers",
  iban: "IBAN",
  hint:
    "Durch das Speichern eines SEPA-Bankkontos erteilst du die Zustimmung zu wiederkehrenden Lastschriften für deine Werbekosten.",
},

wallet: {
  provider: "Wallet-Anbieter",
  apple: "Apple Pay",
  google: "Google Pay",
  hint:
    "Die Verbindung mit deinem Wallet-Anbieter wird bei der nächsten Zahlungsbestätigung abgeschlossen.",
},

security: {
  title: "Sicherheit & Abrechnungsinformationen",
  point1:
    "Karten- und Bankdaten werden über verschlüsselte Verbindungen übertragen und niemals direkt auf unseren Servern gespeichert.",
  point2:
    "Abrechnungen für aktive Kampagnen erfolgen in der Regel einmal täglich und basieren auf Impressionen und Klicks.",
  point3:
    "Du kannst Kampagnen jederzeit in der Werbeübersicht pausieren, um zukünftige Kosten zu vermeiden.",
},

currentMethod: {
  label: "Aktuelle Zahlungsmethode (Beispiel)",
  hint:
    "Neue Abbuchungen erfolgen über die hier gespeicherte Zahlungsmethode. Dieser Bereich zeigt derzeit nur eine Demo-Karte.",
},

smallPrint:
  "Wichtig: Dies ist eine Vorschau der Benutzeroberfläche. In der Produktivumgebung müssen die jeweiligen gesetzlichen Vorschriften (PSD2, SCA, Kartenrichtlinien usw.) eingehalten und ein PCI-konformer Zahlungsanbieter verwendet werden.",
},

// ✅ Diesen Block innerhalb deines bestehenden `ad`-Objekts hinzufügen

billing: {
  title: "Abrechnung verwalten",
  subtitle:
    "Lege Ausgabenlimits fest, überprüfe deine monatlichen Kosten und sieh, wie viel jede Kampagne verbraucht.",

  backToOverview: "Zurück zur Werbeübersicht",
  loading: "Abrechnungsdaten werden geladen...",
  allTime: "Gesamt",

  // Monatslimit
  limitTitle: "Monatliches Ausgabenlimit",
  limitDescription:
    "Lege ein weiches Limit für deine Werbeausgaben in diesem Monat fest. Wir benachrichtigen dich, sobald sich deine Kampagnen diesem Betrag nähern.",
  limitLabel: "Limit für",
  thisPeriod: "diesen Zeitraum",
  saveLimits: "Speichern",
  currentSpend: "Aktuelle Ausgaben",

  hints: {
    safe: "Deine Ausgaben liegen in diesem Monat im sicheren Bereich.",
    approaching:
      "Du näherst dich deinem monatlichen Limit. Erwäge, Budgets zu reduzieren oder einige Kampagnen zu pausieren.",
    exceeded:
      "Du hast dein monatliches Limit überschritten. Laufende Kampagnen können weiterhin Kosten verursachen, sofern du sie nicht pausierst.",
  },

  // Übersicht
  lastMonthsTitle: "Übersicht der letzten Monate",
  lifetimeSpend: "Gesamtausgaben",
  lifetimeImpressions: "Gesamtzahl der Impressionen",
  lifetimeClicks: "Gesamtzahl der Klicks",

  // Monatsstatistik
  monthlyStatsTitle: "Monatliche Statistik",
  table: {
    spend: "Ausgaben",
    impressions: "Impressionen",
    clicks: "Klicks",
    cpm: "Durchschnittlicher CPM",
    cpmHint: "pro 1.000 Impressionen",
    cpc: "Durchschnittlicher CPC",
    cpcHint: "pro Klick",
  },

  // Kampagnenaufschlüsselung
  campaignBreakdownTitle: "Kampagnenübersicht für {{month}}",
  campaignBreakdownEmpty: "In diesem Monat sind für keine Kampagne Kosten angefallen.",
  campaignColumns: {
    name: "Kampagne",
    spend: "Ausgaben",
    impressions: "Impr.",
    clicks: "Klicks",
    view: "Anzeigen",
  },
},

viewDetail: {
  loading: "Kampagne wird geladen…",

  errors: {
    loadFailed: "Werbeanzeige konnte nicht geladen werden.",
    notFound: "Kampagne nicht gefunden.",
  },

  buttons: {
    backToOverview: "Zurück zur Übersicht",
    back: "Zurück",
    pause: "Pausieren",
    resume: "Fortsetzen",
    endCampaign: "Kampagne beenden",
  },

  confirm: {
    endCampaign: "Diese Kampagne beenden? Die Auslieferung wird gestoppt.",
  },

  alerts: {
    updateStatusFailed: "Der Kampagnenstatus konnte nicht aktualisiert werden. Bitte versuche es erneut.",
  },

  header: {
    campaignId: "Kampagnen-ID: {{id}}",
  },

  sections: {
    performance: "Leistung",
    budgetDelivery: "Budget & Auslieferung",
    targeting: "Zielgruppe",
    destination: "Ziel",
    adPreview: "Anzeigenvorschau",
  },

  performance: {
    impressions: "Impressionen",
    clicks: "Klicks",
    ctr: "CTR",
    spendTotal: "Gesamtausgaben",
    cpmEffective: "CPM (effektiv)",
    cpmConfigured: "CPM (festgelegt)",
  },

  budget: {
    dailyBudget: "Tagesbudget",
    totalBudget: "Gesamtbudget",
    unlimited: "Unbegrenzt",
    delivery: "Auslieferung",
    endDate: "Enddatum",
    deliveryValues: {
      light: "Gering (seltener anzeigen)",
      balanced: "Ausgewogen",
      frequent: "Häufig (öfter anzeigen)",
    },
  },

  targeting: {
    worldwide: "Weltweit",
    continents: "Kontinente: {{list}}",
    countries: "Länder: {{list}}",
    cities: "Städte: {{list}}",
    none: "Keine spezifische Zielgruppe",
    hashtags: "Hashtags: {{list}}",
  },

  destination: {
    urlLabel: "URL",
    buttonLabel: "Buttontext",
    dash: "—",
  },

  preview: {
    adCampaignFallback: "Werbekampagne",
    sponsoredFallback: "Gesponsert",
    visitWebsiteFallback: "Website besuchen",
    noMediaAttached: "Keine Medien an diese Werbeanzeige angehängt.",
  },
},

sidebar: {
  heading: "Werbeanzeige einrichten",
  description:
    "Lege fest, auf welche Website Nutzer weitergeleitet werden sollen, wenn sie auf den Button deiner Anzeige tippen.",

  urlLabel: "Ziel-URL",
  urlPlaceholder: "Füge hier deine URL ein, z. B. https://dein-shop.de",
  urlHint:
    "Verwende einen kurzen, ansprechenden Text für den Button, der Interesse an deinem Produkt oder deiner Dienstleistung weckt. Es empfiehlt sich außerdem, den Unternehmensnamen zu verwenden, z. B. „Elnydo besuchen“.",

  buttonLabel: "Buttontext",
  buttonPlaceholder: "z. B. Jetzt kaufen, Mehr erfahren",

  buttons: {
    continue: "Weiter",
    back: "Zurück",
  },
},

} as const;

export default ad;
